<template>
<span>
	<!--<b-link class="ml-3"  href="/agent/my-shop">-->
	<b-link v-if="iamin=='quickview'" class="ml-3"  @click="$root.updateShare(productData)">
	<b-icon class="addtoshopNow" icon="bag" aria-hidden="true" v-b-tooltip.hover title="Add to Shop" placement="bottom"></b-icon>
	<!--<b-icon class="addtoshopNow" icon="shop-window" aria-hidden="true" v-b-tooltip.hover title="Add to Shop" placement="bottom"></b-icon>-->
	</b-link> 
	
	<!--<b-link class="ml-3"  href="/agent/my-shop">-->
	<b-link v-if="iamin=='category'" class="ml-3"  @click="$root.updateShare(productData)">
	<b-icon class="addtoshopNow" icon="bag" aria-hidden="true" v-b-tooltip.hover title="Add to Shop" placement="bottom"></b-icon>
	<!--<b-icon class="addtoshopNow" icon="shop-window" aria-hidden="true" v-b-tooltip.hover title="Add to Shop" placement="bottom"></b-icon>-->
	</b-link> 
	</span>
</template>
<script>
export default {
  name: 'AddtocartButton',
  props: {
    productData: { type: Object },	
    iamin: String,	
  },
  mounted(){
  //this.inLodcard;
  },
  computed: {
    //
  },
  data() {
    return{
      //modaldata_qty: 1,
	  //variant:'dark',
	  //cartHeader:'',
        //{{$root.cart.quantity}}
    }
  },
  methods:{
		addtofavouriteNotlogin(){
			if(this.$root.customer_info.access_key == ''){
				this.$router.push({
					name: 'Login',
					params: {
						redirect: '/category/'+this.$route.params.category
					}
				});
			}
		}
	/* inLodcard(){
	this.cartHeader ='
	} */
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped lang="scss">
.addtoshopNow{
	color: rgb(254 100 111);
    font-size: 30px;
}
</style>
